import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export const CreateSessionPage = () => {
    const isCreateSessionPage = $("#create-session-page").length > 0;
    if (!isCreateSessionPage) return false;

    bdjs.hideLoading();

    let isLoading = false;

    const createSessions = async () => {
        if (isLoading) return false;
        const $submitBtn = $("#create-sessions-btn");
        const numberOfSessions = $("#number-of-sessions").val();

        $submitBtn.addClass("is-loading").prop("disabled", true);
        isLoading = true;
        const [res, err] = await bdjs.goAsync(
            bdapi.post("public/create-sessions", {
                number_of_sessions: numberOfSessions,
            }),
        );

        isLoading = false;
        if (res?.data?.success) {
            $(".js-create-sessions").hide();
            $(".js-sessions-list").show();
            $(".js-sessions-list-content").html(res.data.data.session_list);
        }
    };

    $(document).on("click", "#create-sessions-btn", createSessions);
};
